import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "bank-detail" }
const _hoisted_2 = { class: "loading" }
const _hoisted_3 = { class: "detail" }
const _hoisted_4 = { class: "p__style__4" }
const _hoisted_5 = { class: "p__style__4" }
const _hoisted_6 = { class: "p__style__4" }
const _hoisted_7 = { class: "p__style__4" }
const _hoisted_8 = { class: "p__style__4" }
const _hoisted_9 = { class: "p__style__4" }
const _hoisted_10 = { class: "button-area" }

import { onMounted, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'BankDetail',
  setup(__props) {

const router = useRouter();
// const dateNum = 31;

const userInfoStore = UserInfoStore();
const loading = ref(false);
onMounted(async () => {
  if (!userInfoStore.bankInfo.id) {
    await userInfoStore.getBankInfo();
    document.title = "振込先銀行口座情報";
    // 登録済の情報を初期値で入れる
  }
});

function push() {
  router.push("/bank");
}

function setBankType(bankType: number) {
  if (!bankType) return "普通";
  else return "当座";
}
function setAccountType(accountType: number) {
  if (!accountType) return "個人";
  else return "法人";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _cache[1] || (_cache[1] = [
      _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, loading.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "detail-title" }, "種別", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_4, _toDisplayString(setAccountType(_unref(userInfoStore).bankInfo.account_type)), 1 /* TEXT */),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "detail-title" }, "銀行口座", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(userInfoStore).bankInfo.bank_name), 1 /* TEXT */),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "detail-title" }, "口座種別", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_6, _toDisplayString(setBankType(_unref(userInfoStore).bankInfo.bank_type)), 1 /* TEXT */),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "detail-title" }, "支店", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(userInfoStore).bankInfo.bank_branch), 1 /* TEXT */),
      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "detail-title" }, "口座番号", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(userInfoStore).bankInfo.bank_code), 1 /* TEXT */),
      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "detail-title" }, "口座名義", -1 /* HOISTED */)),
      _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(userInfoStore).bankInfo.bank_account_name), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(CommonButton, {
        data: {
          status: 0,
          button: `更新する`,
        },
        style: {"max-width":"317px"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (push()))
      })
    ])
  ]))
}
}

})